import { IFacetGroup } from 'shared/models/facet';
import { IFollowUp } from 'shared/models/followUp';
import dateService, { dateFormats } from 'shared/services/dateService';

import {
  formatDateTime,
  IPrepareBreakdownTitleData,
  IPrepareBreakdownTitleOptions,
  prepareBreakdownDataTitle,
} from './breakdownViewHelpers';

export interface IPrepareSentTexts {
  senderInfoFormat: string;
  dateTimeFormat: string;
}

export interface IPrepareFollowUpTitleOptions extends IPrepareBreakdownTitleOptions {
  titleUpdateLabel: string;
}

function prepareFollowUpDataTitle(data: IPrepareBreakdownTitleData, options: IPrepareFollowUpTitleOptions) {
  return `${prepareBreakdownDataTitle(data, options)} (${options.titleUpdateLabel})`;
}

export function prepareFollowUpTitle(followUp: IFollowUp, options: IPrepareFollowUpTitleOptions) {
  return prepareFollowUpDataTitle({ ...followUp, title: followUp.subject }, options);
}

export function prepareRecipientsInfo(
  recipientsFormat: string,
  followUp: IFollowUp,
  productionTypes: IFacetGroup[],
  linkmailTypeAmendment: string
) {
  return recipientsFormat
    .replace(
      '{title}',
      prepareBreakdownDataTitle(
        {
          title: followUp.productionTitle,
          productionTypeId: followUp.productionTypeId,
          linkmailType: followUp.linkmailType,
          amendmentCount: followUp.amendmentCount,
        },
        { productionTypes, linkmailTypeAmendment }
      )
    )
    .replace('{date}', dateService.format(followUp.linkmailSentDate, dateFormats.fullDateLongTime));
}

export function prepareSent(texts: IPrepareSentTexts, followUp: IFollowUp): string {
  const sentOnDate = formatDateTime(texts.dateTimeFormat, followUp.created);

  return texts.senderInfoFormat.replace('{sender}', followUp.sentBy).replace('{date}', sentOnDate).trim();
}
